import button from "./button";

export default {
    button,
};
